import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { QuestionCircleOutlined, RightOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useSize, useReactive, useScroll } from "ahooks";
import general from "../../../general";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import $ from "jquery";
import dayjs from "dayjs";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { sysUrl, activityUrl } from "../../../config";
import { NavLink } from "../../../lib/Navigation";

export default (props) => {
  let [game, setGame] = useState({});
  const openService = useReactive({
    info: {
      dayTime: "",
      serviceName: "",
    },
  });
  const [init, setInit] = useState();
  useEffect(() => {
    game = props.game;
    setGame(props.game);

    let list = props.game.kaifu_info;
    if (list && list.length > 0) {
      console.log(list);
      // 获取当前时间 若第一项为今日日期  则显示今天 00:00(截取时间)
      let nowDay = dayjs().format("MM.DD");
      let firstTime = dayjs
        .unix(game.game_control_info?.server_info?.starttime)
        .format("MM.DD HH:mm");
      // console.log(nowDay, firstTime);

      if (nowDay === firstTime.split(" ")[0]) {
        openService.info.dayTime = "今天 " + firstTime.split(" ")[1];
      } else {
        openService.info.dayTime = firstTime;
      }
      openService.info.serviceName =
        game.game_control_info?.server_info?.kaifuname;
    }

    setInit(true);
  }, [props.game]);

  const [inlineBenefitMore, setInlineBenefitMore] = useState(true);
  const [inlineBenefitMored, setInlineBenefitMored] = useState(false);
  const inlineBenefitBodyRef = useRef();
  const inlineBenefitEntityRef = useRef();
  const inlineBenefitBodySize = useSize(inlineBenefitBodyRef);
  const inlineBenefitEntitySize = useSize(inlineBenefitEntityRef);
  useEffect(() => {
    !inlineBenefitMored &&
      setInlineBenefitMore(
        inlineBenefitEntitySize?.height > inlineBenefitBodySize?.height
      );
  }, [inlineBenefitBodySize, inlineBenefitEntitySize]);

  const [welfareMore, setWelfareMore] = useState(true);
  const [welfareMored, setWelfareMored] = useState(false);
  const welfareBodyRef = useRef();
  const welfareEntityRef = useRef();
  const welfareBodySize = useSize(welfareBodyRef);
  const welfareEntitySize = useSize(welfareEntityRef);
  useEffect(() => {
    !welfareMored &&
      setWelfareMore(welfareEntitySize?.height > welfareBodySize?.height);
  }, [welfareBodySize, welfareEntitySize]);

  const [rebateMore, setRebateMore] = useState(true);
  const [rebateMored, setRebateMored] = useState(false);
  const rebateBodyRef = useRef();
  const rebateEntityRef = useRef();
  const rebateBodySize = useSize(rebateBodyRef);
  const rebateEntitySize = useSize(rebateEntityRef);
  useEffect(() => {
    !rebateMored &&
      setRebateMore(rebateEntitySize?.height > rebateBodySize?.height);
  }, [rebateBodySize, rebateEntitySize]);

  const [manufacturerMore, setManufacturerMore] = useState(true);
  const [manufacturerMored, setManufacturerMored] = useState(false);
  const manufacturerBodyRef = useRef();
  const manufacturerEntityRef = useRef();
  const manufacturerBodySize = useSize(manufacturerBodyRef);
  const manufacturerEntitySize = useSize(manufacturerEntityRef);
  useEffect(() => {
    !manufacturerMored &&
      setManufacturerMore(
        manufacturerEntitySize?.height > manufacturerBodySize?.height
      );
  }, [manufacturerBodySize, manufacturerEntitySize]);

  const imgRef = useCallback((node) => {
    if (node) {
      let container = $(node).find(".container")[0];
      var startScroll, touchStart, touchCurrent;
      node.addEventListener(
        "touchstart",
        (e) => {
          startScroll = container.scrollLeft;
          touchStart = e.targetTouches[0].pageX;
        },
        { passive: false }
      );
      node.addEventListener(
        "touchmove",
        (e) => {
          touchCurrent = e.targetTouches[0].pageX;
          var touchesDiff = touchCurrent - touchStart;
          var onlyScrolling =
            container.scrollWidth > container.offsetWidth &&
            ((touchesDiff < 0 && startScroll === 0) ||
              (touchesDiff > 0 &&
                startScroll ===
                  container.scrollWidth - container.offsetWidth) ||
              (startScroll > 0 &&
                startScroll < container.scrollWidth - container.offsetWidth));
          if (onlyScrolling) {
            e.stopPropagation();
          }
        },
        { passive: false }
      );
    }
  }, []);

  const recommend = () => {
    Dialog.loading();
    general.axios
      .post("/v3/base/newindex/GameLike", { game_id: game.game_id })
      .finally(() => {
        Dialog.close();
      })
      .then((response) => {
        let { status, data } = response.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        props.setGame((game) => ({ ...game, recommend_info: data.list }));
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  const videoRef = useRef(null);
  const [videoHeight, setVideoHeight] = useState(null);

  // 获取 video 高度并设置到 bannerImg
  useEffect(() => {
    const setBannerImgHeight = (height) => {
      if (height) {
        const bannerImgs = document.querySelectorAll(".bannerImg");
        bannerImgs.forEach((img) => {
          $(img).css("height", `${height}px`);
        });
      }
    };

    const getVideoHeight = () => {
      if (videoRef.current) {
        const height =
          videoRef.current.offsetHeight || videoRef.current.videoHeight;
        if (height) {
          const ceilHeight = Math.ceil(height);
          setVideoHeight(ceilHeight);
          setBannerImgHeight(ceilHeight);
        }
      }
    };

    const handleVideoLoadedMetadata = () => {
      getVideoHeight();
    };

    if (videoRef.current) {
      videoRef.current.addEventListener(
        "loadedmetadata",
        handleVideoLoadedMetadata
      );
      videoRef.current.addEventListener(
        "loadeddata",
        handleVideoLoadedMetadata
      );
      // 如果已经加载完成，直接获取高度
      if (videoRef.current.readyState >= 1) {
        handleVideoLoadedMetadata();
      }
    }

    return () => {
      if (videoRef.current) {
        videoRef.current.removeEventListener(
          "loadedmetadata",
          handleVideoLoadedMetadata
        );
        videoRef.current.removeEventListener(
          "loadeddata",
          handleVideoLoadedMetadata
        );
      }
    };
  }, [game.video_url]);

  // 监听窗口大小变化，重新获取 video 高度
  useEffect(() => {
    const handleResize = () => {
      if (videoRef.current && game.video_url) {
        const height =
          videoRef.current.offsetHeight || videoRef.current.videoHeight;
        if (height) {
          const ceilHeight = Math.ceil(height);
          setVideoHeight(ceilHeight);
          const bannerImgs = document.querySelectorAll(".bannerImg");
          bannerImgs.forEach((img) => {
            $(img).css("height", `${ceilHeight}px`);
          });
        }
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [game.video_url]);

  // 当 bannerImg 渲染后，如果有 videoHeight，应用高度
  useEffect(() => {
    if (videoHeight && game.game_ur_list?.length > 0) {
      const bannerImgs = document.querySelectorAll(".bannerImg");
      bannerImgs.forEach((img) => {
        $(img).css("height", `${videoHeight}px`);
      });
    }
  }, [videoHeight, game.game_ur_list]);

  let [giftCode, setGiftCode] = useState("");

  const menuRef = useRef(null);
  const menuScroll = useScroll(menuRef);
  const scrollbarRef = useRef(null);

  useEffect(() => {
    if (menuRef.current && !init) {
      setTimeout(() => {
        $(menuRef.current).css({
          scrollLeft: 0,
        });

        $(scrollbarRef.current).css({
          width: "38%",
          left: 0,
        });
      }, 200);

      // setTimeout(() => {
      //   $(menuRef.current).animate(
      //     { scrollLeft: menuRef.current?.offsetWidth || 0 },
      //     1000,
      //     null,
      //     () => {
      //       $(menuRef.current).animate({ scrollLeft: 0 }, 1000);
      //     }
      //   );
      // }, 250);
    }
  }, [init]);

  useEffect(() => {
    if (menuRef.current && menuScroll && scrollbarRef.current) {
      $(scrollbarRef.current).css({
        left: `${
          ((menuScroll.left + $(menuRef.current).width() / 2) /
            menuRef.current.scrollWidth) *
          100
        }%`,
      });

      $(scrollbarRef.current).css({
        width: `${
          ($(menuRef.current).width() / menuRef.current.scrollWidth) * 100
        }%`,
        // width: "38%",
      });
    }
  }, [menuScroll]);

  // 领取648
  const getSixGift = () => {
    if (game.game_control_info?.is_have === 1) {
      general.axios
        .post("/v3/base/game/receive", {
          id: game.game_control_info?.gift_id,
        })
        .then((res) => {
          console.log("领取648-----", res.data);
          let { status, data } = res.data;
          if (!status.succeed) {
            Dialog.error(status.error_desc);
            return;
          }

          giftCode = data;
          setGiftCode(data);
          console.log("55555555555555555555");
          // game.game_control_info.is_have = 2;
          props.setGame({
            ...game,
            game_control_info: {
              ...game.game_control_info,
              is_have: 2,
            },
          });

          Dialog.alert(
            "领取成功",
            <div>
              <div className="gift-pack-code">
                <p>
                  礼包码：<span className="code">{giftCode}</span>
                </p>
                <p style={{ marginTop: "3px" }}>(前往游戏内使用)</p>
              </div>
              <div className="gift-pack-code-font">游戏→我的礼包，查看使用</div>
            </div>,
            () => {
              Dialog.info("复制成功");
            },
            {
              btn: (
                <CopyToClipboard text={giftCode}>
                  <span className="copy">复 制</span>
                </CopyToClipboard>
              ),
            }
          );
        })
        .catch((err) => {
          //Dialog.error('getTradeList ' + err.message);
        });
    } else {
      Dialog.alert(
        "领取成功",
        <div>
          <div className="gift-pack-code">
            <p>
              礼包码：
              <span className="code">
                {game.game_control_info?.giftCode || giftCode}
              </span>
            </p>
            <p style={{ marginTop: "3px" }}>(前往游戏内使用)</p>
          </div>
          <div className="gift-pack-code-font">游戏→我的礼包，查看使用</div>
        </div>,
        () => {
          Dialog.info("复制成功");
        },
        {
          btn: (
            <CopyToClipboard
              text={game.game_control_info?.giftCode || giftCode}
            >
              <span className="copy">复 制</span>
            </CopyToClipboard>
          ),
        }
      );
    }
  };

  return (
    <div className="game-index">
      <div className="game-imgs" ref={imgRef}>
        <div className="container" ref={menuRef}>
          <div className="img">
            {game.video_url && (
              <div className="video-main">
                <div className="game-video">
                  <video
                    ref={videoRef}
                    autoPlay
                    muted
                    controls
                    webkit-playsinline="true"
                    playsInline={true}
                    loop
                    src={game.video_url}
                    type="video/mp4"
                  ></video>
                </div>
              </div>
            )}

            {game.game_ur_list?.map((img, index, imgs) => (
              <Link
                key={index}
                to={"/img?imgs=" + imgs + "&img=" + index}
                className="bannerImg"
              >
                <Image src={img} alt="" />
              </Link>
            ))}
          </div>

          <div className="scrollbar">
            <div className="thumb" ref={scrollbarRef} />
          </div>
        </div>
      </div>

      <div className="game-info-content">
        <div className="game-list-global-type">
          <div className="game-list-global-type-left">
            <div className="icon">
              <Image src={game?.game_image?.thumb} />
            </div>
            <div className="data">
              <div className="name" style={{ marginBottom: "9px" }}>
                <div className="name-main" style={{ flex: "none" }}>
                  {game.game_name_main || game.game_name}
                </div>
              </div>

              {game.game_name_branch && (
                <div className="desc" style={{ marginBottom: "0" }}>
                  {game.game_name_branch}
                </div>
              )}
            </div>
          </div>

          {game?.game_tags?.is_premium_game == 2 ? (
            <div
              className="is-premium"
              style={{
                backgroundImage: "url('/resources/common/boutique.png')",
              }}
            >
              {game.discount < 1 ? (
                <p className="is-premium-discount">
                  {parseFloat((game.discount * 10).toFixed(2))}折
                </p>
              ) : null}
              <p className="boutique">精品游戏</p>
            </div>
          ) : game?.game_tags?.is_free_version == 2 ? (
            <div className="is-free-version">
              <span>免费版</span>
            </div>
          ) : (
            <>
              {game.discount < 1 ? (
                <div
                  className="is-free-version"
                  style={{ fontSize: "0.32rem", letterSpacing: "1px" }}
                >
                  {parseFloat((game.discount * 10).toFixed(2))}
                  <span style={{ fontSize: "0.24rem" }}>折</span>
                </div>
              ) : null}
            </>
          )}
        </div>

        <div className="game-tag">
          {game.game_classify_name?.map((item) => (
            <Fragment key={item.id}>
              {item.tagname == "专服" && item.is_special_server_game == 2 ? (
                <div className="tag-every">
                  <NavLink
                    user={false}
                    to={`${sysUrl}/home/actcloudhook/game?id=0&type=3&device=10`}
                    iframe={{ title: item.tagname }}
                  >
                    {item.tagname}
                    <img
                      src="/resources/game/label-more.png"
                      style={{ width: "8px" }}
                    />
                  </NavLink>
                </div>
              ) : item.tagname == "有奖试玩" && item.is_trial_game == 2 ? (
                <div className="tag-every">
                  <NavLink
                    user={false}
                    to={`${activityUrl}/play-win`}
                    iframe={{ title: "有奖试玩" }}
                  >
                    有奖试玩
                    <img
                      src="/resources/game/label-more.png"
                      style={{ width: "8px" }}
                    />
                  </NavLink>
                </div>
              ) : (
                <>
                  {item.tagname != "专服" && item.tagname != "有奖试玩" && (
                    <div className="tag-every">
                      <NavLink
                        user={false}
                        to={`${sysUrl}/home/actcloudhook/game?id=${item.id}&type=${item.type}&device=10`}
                        iframe={{ title: item.tagname }}
                      >
                        {item.tagname}
                        <img
                          src="/resources/game/label-more.png"
                          style={{ width: "8px" }}
                        />
                      </NavLink>
                    </div>
                  )}
                </>
              )}
            </Fragment>
          ))}

          {game.cloud_hanging_up?.list?.map((item) => (
            <div key={item.id} className="tag-every">
              <NavLink
                user={false}
                to={`${sysUrl}/home/actcloudhook/game?id=${item.id}&type=${item.type}&device=10`}
                iframe={{ title: item.title }}
              >
                {item.title}
                <img
                  src="/resources/game/label-more.png"
                  style={{ width: "8px" }}
                />
              </NavLink>
            </div>
          ))}
        </div>

        <div className="game-tab">
          <div
            className="tab-every"
            style={{
              display:
                game.kaifu_info &&
                game.kaifu_info.length > 0 &&
                openService.info?.serviceName != "动态开服"
                  ? "unset"
                  : "flex",
              alignItems: "center",
            }}
            onClick={() => {
              props.setServerShow(true);
            }}
          >
            <div
              className="every-top"
              style={{
                marginRight: 0,
                alignItems: "center",
              }}
            >
              {game.kaifu_info &&
              game.kaifu_info.length > 0 &&
              openService.info?.serviceName != "动态开服"
                ? openService.info?.dayTime
                : "动态开服中"}
            </div>
            <div
              className="every-bottom"
              style={{
                marginTop:
                  game.kaifu_info &&
                  game.kaifu_info.length > 0 &&
                  openService.info?.serviceName != "动态开服"
                    ? "5px"
                    : "0",
                alignItems: "center",
              }}
            >
              {/* 以游戏内实际开服为准 */}
              {game.kaifu_info &&
              game.kaifu_info.length > 0 &&
              openService.info?.serviceName != "动态开服" ? (
                <span className="bottom-info">
                  {openService.info?.serviceName}
                </span>
              ) : (
                ""
              )}

              {game.kaifu_info &&
              game.kaifu_info.length > 0 &&
              openService.info?.serviceName != "动态开服" ? (
                <RightOutlined style={{ fontSize: "8px" }} />
              ) : (
                <img
                  src="/resources/game/server-arrow.png"
                  alt=""
                  style={{ width: "18px" }}
                />
              )}
            </div>
          </div>

          <div className="line"></div>

          <Link to={"/game/gift?id=" + game.game_id} className="tab-every">
            <div className="every-top">
              {(game.gift_bag_list?.length && game.gift_bag_list?.length) || 0}
            </div>
            <div className="every-bottom">
              <span className="bottom-info">礼包</span>
              <RightOutlined style={{ fontSize: "8px" }} />
            </div>
          </Link>

          <div className="line"></div>

          <Link to={"/game/voucher?id=" + game.game_id} className="tab-every">
            <div className="every-top">￥{game.voucher_info?.amount || 0}</div>
            <div className="every-bottom">
              <span className="bottom-info">代金券</span>
              <RightOutlined style={{ fontSize: "8px" }} />
            </div>
          </Link>

          <div className="line"></div>

          <Link
            to={`/game/articleGroup?game_id=${game.game_id}`}
            className="tab-every"
          >
            <div className="every-top">{game?.game_activity_total || 0}</div>
            <div className="every-bottom">
              <span className="bottom-info">返利</span>
              <RightOutlined style={{ fontSize: "8px" }} />
            </div>
          </Link>
        </div>

        {game.game_control_info?.is_have !== 0 && (
          <div className="game-648">
            <div className="left">
              <img src="/resources/game/card.png" alt="" />
              <span>648礼包</span>
            </div>
            <NavLink
              className="btn"
              user={true}
              onClick={() => {
                getSixGift();
              }}
            >
              {game.game_control_info?.is_have === 1 ? "领取" : "去使用"}
            </NavLink>
          </div>
        )}
      </div>

      <div className="game-explain">
        {game.iosProblemData && game.iosProblemData.length > 0 && (
          <div className="item itemThree">
            <div className="head">
              <div className="subject">
                <div className="title">IOS安装常见问题</div>
              </div>
            </div>

            <div className="questions-container">
              {game.iosProblemData.map((item) => (
                <Link
                  key={item.id}
                  to={`/question?id=${item.id}`}
                  className="questions-every"
                >
                  <div className="title">{item.title}</div>
                  <img
                    src="/resources/game/right.png"
                    alt=""
                    style={{ width: "20px" }}
                  />
                </Link>
              ))}
            </div>
          </div>
        )}

        {game.game_feature_list && game.game_feature_list[0].content && (
          <div className="item">
            <div className="head">
              <div className="subject">
                <div className="title">上线福利</div>

                {game.game_control_info?.double_ended === 1 && (
                  <div
                    className="icon-tips"
                    onClick={() =>
                      Dialog.alert(
                        "温馨提示",
                        <div
                          style={{
                            padding: "0 11px",
                            fontSize: "0.24rem",
                            lineHeight: "22px",
                            color: "#666",
                            textAlign: "center",
                          }}
                        >
                          双端互通就是游戏的数据在安卓端和苹果端都能进行角色互通共享的游戏！
                        </div>,
                        () => {},
                        {
                          btn: "我知道了",
                        }
                      )
                    }
                  >
                    双端互通
                    <QuestionCircleOutlined style={{ marginLeft: "2px" }} />
                  </div>
                )}
              </div>
            </div>

            <div className="main-container">
              <div
                className={"body " + (inlineBenefitMored ? "more" : "")}
                ref={inlineBenefitBodyRef}
              >
                <div
                  className="entity ty-one"
                  ref={inlineBenefitEntityRef}
                  dangerouslySetInnerHTML={{
                    __html: game.game_feature_list
                      ? game.game_feature_list[0].content
                          .replace(/(\r\n|\n\r|\r|\n)+/g, "<br>")
                          .replace(
                            /★/gi,
                            `<div style="width:11px;height:11px;margin-right: 3px;display: inline-block;background-color: #3d3d3d;clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);"></div>`
                          )
                      : null,
                  }}
                />
                {/* width:11px;height:11px;margin-right: 3px;background-color:#fff;border-radius:50%;display: inline-block;border: 4px solid #FB7574; */}
                {inlineBenefitMore && (
                  <div
                    className={"more " + (inlineBenefitMored ? "ed" : "")}
                    onClick={() => setInlineBenefitMored(!inlineBenefitMored)}
                  >
                    {inlineBenefitMored ? (
                      <img
                        src="/resources/game/top.png"
                        alt=""
                        style={{ width: "20px" }}
                      />
                    ) : (
                      <img
                        src="/resources/game/bottom.png"
                        alt=""
                        style={{ width: "20px" }}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {game.game_feature_list && game.game_feature_list[1].content && (
          <div className="item itemTwo">
            <div className="head">
              <div className="subject">
                <div className="title">返利</div>
                {/* 允许 1 手动   不允许 0 自动*/}
                {game.allow_rebate === 1 ? (
                  <>
                    <div
                      className="icon-tips"
                      onClick={() =>
                        Dialog.alert(
                          "温馨提示",
                          <div
                            style={{
                              padding: "0 11px",
                              fontSize: "0.24rem",
                              lineHeight: "22px",
                              color: "#666",
                              textAlign: "center",
                            }}
                          >
                            手动返利：充值达到返利标准后，需要通过APP手动申请返利，提交审核后-般24小时内到账
                          </div>,
                          () => {},
                          {
                            btn: "我知道了",
                          }
                        )
                      }
                    >
                      手动返利
                      <QuestionCircleOutlined style={{ marginLeft: "2px" }} />
                    </div>
                  </>
                ) : game.allow_rebate === 0 ? (
                  <>
                    <div
                      className="icon-tips"
                      onClick={() =>
                        Dialog.alert(
                          "温馨提示",
                          <div
                            style={{
                              padding: "0 11px",
                              fontSize: "0.24rem",
                              lineHeight: "22px",
                              color: "#666",
                              textAlign: "center",
                            }}
                          >
                            自动返利：充值达到返利标准后，无须手动申请，游戏一般为次日0点会自动发放到账！
                          </div>,
                          () => {},
                          {
                            btn: "我知道了",
                          }
                        )
                      }
                    >
                      自动返利
                      <QuestionCircleOutlined style={{ marginLeft: "2px" }} />
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="icon-tips"
                      onClick={() =>
                        Dialog.alert(
                          "温馨提示",
                          <div
                            style={{
                              padding: "0 11px",
                              fontSize: "0.24rem",
                              lineHeight: "22px",
                              color: "#666",
                              textAlign: "center",
                            }}
                          >
                            无返利：代表此游戏没有充值返利
                          </div>,
                          () => {},
                          {
                            btn: "我知道了",
                          }
                        )
                      }
                    >
                      无返利
                      <QuestionCircleOutlined style={{ marginLeft: "2px" }} />
                    </div>
                  </>
                )}
              </div>
              {game.allow_rebate === 1 ? (
                <Link to={"/rebate?id=" + game.game_id} className="operate">
                  申请返利&gt;
                </Link>
              ) : null}
            </div>

            <div
              className={"body bodyTwo " + (rebateMored ? "more" : "")}
              ref={rebateBodyRef}
              style={{ marginTop: "8px" }}
            >
              <div
                className="entity"
                ref={rebateEntityRef}
                dangerouslySetInnerHTML={{
                  __html: game.game_feature_list
                    ? game.game_feature_list[1].content.replace(
                        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
                        "$1<br>$2"
                      )
                    : null,
                }}
              />
              {rebateMore && (
                <div
                  className={"more " + (rebateMored ? "ed" : "")}
                  onClick={() => setRebateMored(!rebateMored)}
                >
                  {rebateMored ? (
                    <img
                      src="/resources/game/top.png"
                      alt=""
                      style={{ width: "20px" }}
                    />
                  ) : (
                    <img
                      src="/resources/game/bottom.png"
                      alt=""
                      style={{ width: "20px" }}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        <div className="item itemThree">
          <div className="head">
            <div className="subject">
              <div className="title">游戏介绍</div>
            </div>
          </div>

          <div
            className={"body bodyThree " + (welfareMored ? "more" : "")}
            ref={welfareBodyRef}
            style={{ marginTop: "8px" }}
          >
            <div
              className="entity"
              ref={welfareEntityRef}
              dangerouslySetInnerHTML={{
                __html: (
                  game?.game_introduce_main || game?.game_introduce
                )?.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br>$2"),
              }}
            />
            {welfareMore && (
              <div
                className={"more " + (welfareMored ? "ed" : "")}
                onClick={() => setWelfareMored(!welfareMored)}
              >
                {welfareMored ? (
                  <img
                    src="/resources/game/top.png"
                    alt=""
                    style={{ width: "20px" }}
                  />
                ) : (
                  <img
                    src="/resources/game/bottom.png"
                    alt=""
                    style={{ width: "20px" }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {game.vipprice ? (
        <>
          <Link
            to={`/game/vip?game=${game.game_name_main}`}
            onClick={() => {
              localStorage.setItem("vipWatchContent", game.vipprice);
            }}
          >
            <div className="game-vip">
              <div className="vip-left">
                <img src="/resources/game/vip.png" alt="" />
                <div className="title">《{game.game_name_main}》VIP表</div>
              </div>

              <img
                src="/resources/game/right.png"
                alt=""
                style={{ width: "20px" }}
              />
            </div>
          </Link>
        </>
      ) : null}

      <div className="game-manufacturer">
        <div
          className={"body bodyFour " + (manufacturerMored ? "more" : "")}
          ref={manufacturerBodyRef}
        >
          <div className="entity" ref={manufacturerEntityRef}>
            <div className="every">
              <p className="title">厂商信息</p>
              <p className="font">{game.game_control_info?.company_name}</p>
            </div>
            <div className="every">
              <p className="title">当前版本</p>
              <p className="font">{game.game_control_info?.version?.ios}</p>
            </div>
            {game.game_control_info?.filings_number && (
              <div className="every">
                <p className="title">软件备案</p>
                <p className="font">{game.game_control_info?.filings_number}</p>
              </div>
            )}

            {game.game_control_info?.authority_info ||
            game.game_control_info?.privacy_policy ? (
              <div className="every">
                <p className="title">隐私权限</p>
                {game.game_control_info?.authority_info && (
                  <p className="font">
                    权限信息
                    <NavLink
                      className="img"
                      user={false}
                      to={`${sysUrl}/home/CompanyJurisdiction?gameId=${game.game_id}&maiyouGameId=${game.maiyou_gameid}&device=web`}
                      iframe={{ title: "权限信息" }}
                    >
                      <span className="btn">查看</span>
                    </NavLink>
                  </p>
                )}

                {game.game_control_info?.privacy_policy && (
                  <p className="font" style={{ marginLeft: "16px" }}>
                    隐私政策
                    <NavLink
                      className="img"
                      user={false}
                      to={`${sysUrl}/home/CompanyJurisdiction/web?gameId=${game.game_id}&maiyouGameId=${game.maiyou_gameid}&device=web`}
                      iframe={{ title: "隐私政策" }}
                    >
                      <span className="btn">查看</span>
                    </NavLink>
                  </p>
                )}
              </div>
            ) : null}
          </div>
          {manufacturerMore && (
            <div
              className={"more " + (manufacturerMored ? "ed" : "")}
              onClick={() => setManufacturerMored(!manufacturerMored)}
            >
              {manufacturerMored ? (
                <img
                  src="/resources/game/top.png"
                  alt=""
                  style={{ width: "20px" }}
                />
              ) : (
                <img
                  src="/resources/game/bottom.png"
                  alt=""
                  style={{ width: "20px" }}
                />
              )}
            </div>
          )}
        </div>
      </div>

      <div className="game-games">
        <div className="head">
          <div className="text">猜你喜欢</div>
          <div className="operate" onClick={() => recommend()}>
            <img className="icon" src="/resources/game/refresh.png" />
            换一批
          </div>
        </div>
        <div className="body">
          {game.recommend_info?.map((game) => (
            <Link
              key={game.game_id}
              to={"/game?id=" + game.game_id}
              className="item"
            >
              <div className="icon">
                <Image src={game.game_image.thumb} alt="" />
                {game.discount && game.discount < 1 && (
                  <div className="discount">
                    <span style={{ fontSize: "0.24rem", fontWeight: "bold" }}>
                      {parseFloat((game.discount * 10).toFixed(2))}
                    </span>
                    <span style={{ fontSize: "0.2rem" }}>折</span>
                  </div>
                )}
              </div>
              <div className="name">
                {game.game_name_main || game.game_name}
              </div>
              {game.game_name_branch && (
                <div className="branch">
                  <p>{game.game_name_branch}</p>
                </div>
              )}
            </Link>
          ))}
        </div>
      </div>
      <NavLink to={"/service"} className="game-help">
        此游戏有问题？<span>点击反馈</span>
      </NavLink>
    </div>
  );
};
